export class ExpensesLogisticsCreateDto {

    expensesLogisticsId?: number;
    saleOrderId?: number;
    chaBill?:number;
    oceanFrieght?: number;
    domesticFrieght?: number;
    salesComission?: number;
    antiDumpingDuty?: number;
    cvd?: number;
    clearingForwarding?: number;
    ddpTransport?: number;
    marineInsurance?: number;
    amc?: number;
    dutyDrawback?: number;
    rodtepAmount?: number;
    fdaDueDate?: string;
    remarks?: string;
    
    constructor(
        expensesLogisticsId?: number,
    saleOrderId?: number,
    chaBill?:number,
    oceanFrieght?: number,
    domesticFrieght?: number,
    salesComission?: number,
    antiDumpingDuty?: number,
    cvd?: number,
    clearingForwarding?: number,
    ddpTransport?: number,
    marineInsurance?: number,
    amc?: number,
    dutyDrawback?: number,
    rodtepAmount?: number,
    fdaDueDate?: string,
    remarks?: string,
            )
            {
           this.expensesLogisticsId=expensesLogisticsId
           this.chaBill=chaBill
           this.oceanFrieght=oceanFrieght    
           this.domesticFrieght=domesticFrieght
           this.salesComission=salesComission
           this.antiDumpingDuty=antiDumpingDuty
           this.cvd=cvd
           this.clearingForwarding=clearingForwarding
           this.ddpTransport=ddpTransport
           this.marineInsurance=marineInsurance
           this.amc=amc
           this.dutyDrawback=dutyDrawback
           this.rodtepAmount=rodtepAmount
           this.fdaDueDate=fdaDueDate
           this.remarks=remarks
           this.saleOrderId=saleOrderId
        }
}

